import { useEffect, useRef } from "react";

import { MultipleQueriesQuery } from "@algolia/client-search";
import algoliasearch from "algoliasearch/lite";

export const useSearch = (search: boolean) => {
  const algoliaClient = algoliasearch(
    `${process.env.NEXT_PUBLIC_ALGOLIA_APP_ID}`,
    `${process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_API_Key}`
  );
  const indexName = `${process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME}`;
  const mock = {
    hits: [],
    nbHits: 0,
    nbPages: 0,
    page: 0,
    processingTimeMS: 0,
  };
  const searchClient = {
    ...algoliaClient,
    search(requests: MultipleQueriesQuery[]) {
      if (requests.every(({ params }) => !params?.query)) {
        return Promise.resolve(mock);
      }
      return algoliaClient.search(requests);
    },
  };

  const searchRef = useRef<any>(null);
  useEffect(() => {
    if (!search || !searchRef || !searchRef.current) return;
    const searchInput = searchRef.current.getElementsByClassName(
      "ais-SearchBox-input"
    )[0];
    searchInput && searchInput.focus();
  }, [search, searchRef]);

  return { searchRef, indexName, searchClient };
};
